import React, { FC } from 'react';
import {
  Title,
  FormWrapper,
  Header,
  CloseModalButton,
  LeftSideBarWrapper,
  Modal,
  MobileHeading,
  PrevStepButton,
  InnerScroller,
} from '@common/components/BookingForms';

type TableConfigurationWizardV2Props = {
  handleClose: () => void;
  isModalOpen: boolean;
  restaurantName?: string;
  children: React.ReactNode;
};

export const TableConfigurationWizardV2: FC<TableConfigurationWizardV2Props> = ({
  handleClose,
  isModalOpen,
  restaurantName,
  children,
}) => {
  return (
    <Modal isVisible={isModalOpen}>
      <Header>
        <PrevStepButton onClick={handleClose} />
        <MobileHeading>{restaurantName}</MobileHeading>
        <CloseModalButton onClick={handleClose} />
      </Header>
      <InnerScroller>
        <FormWrapper>
          <Title titleId="tables.bookTable" />
          <LeftSideBarWrapper>{children}</LeftSideBarWrapper>
        </FormWrapper>
      </InnerScroller>
    </Modal>
  );
};

export default TableConfigurationWizardV2;
